<template>
  <IconTooltip
    :contentContainerClass="$style.contentContainer"
    :iconClass="$style.icon"
    :iconComponent="IconInfo"
    :linkHref="linkHref"
    :pText="pText"
    :showTooltip="showTooltip"
  >
    <div :class="$style.tooltipContent">
      <p>{{ pText }}</p>
      <ExternalLink
        v-for="(tooltip, index) in tooltipLinks"
        :key="index"
        :class="$style.tooltipLink"
        :href="tooltip.href"
        :text="tooltip.text"
      />
    </div>
  </IconTooltip>
</template>

<script>
import ExternalLink from 'client/components/ExternalLink.vue';
import IconInfo from 'public/img/icons/nav/icon-header-info.svg?inline';
import IconTooltip from 'client/components/Tooltip/IconTooltip.vue';

export default {
  name: 'GettingStartedIconTooltip',

  components: {
    ExternalLink,
    IconTooltip,
  },

  props: {
    linkHref: {
      default: '',
      type: String,
    },
    pText: {
      type: String,
      required: true,
    },
    tooltipExtraLinks: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      IconInfo,
    };
  },

  computed: {
    showTooltip() {
      return !!this.pText;
    },

    tooltipLinks() {
      const tooltipLinks = [
        {
          href: this.linkHref,
          text: 'View Getting Started Guide',
        },
      ];

      return tooltipLinks.concat(this.tooltipExtraLinks);
    },
  },
};
</script>

<style module>
@value (jcInformationalBase) from '~css/brand-colors.css';

.icon {
  fill: currentColor;
  font-size: 16px;
  height: 1em;
  position: relative;
  width: 1em;
}

.contentContainer {
  left: -35px;
  max-width: 400px;
  padding: 16px;
  top: -35px;
}

.tooltipContent {
  font-size: 12px;
}

.tooltipLink {
  color: jcInformationalBase;
  display: inline-block;
}

.tooltipLink:not(:first-of-type) {
  margin-top: 8px;
}
</style>
